<template>
  <div>
    <div class="filter-card">
      <el-form :model="query" inline label-width="78px" size="small">
        <el-form-item label="品牌"><el-input v-model="query.brandName" clearable placeholder="品牌" /></el-form-item>
        <el-form-item label="货号"><el-input v-model="query.itemNo" clearable placeholder="货号" /></el-form-item>
        <el-form-item label="品类">
          <el-select v-model="query.category" clearable placeholder="全部" style="width:120px">
            <el-option v-for="c in categories" :key="c" :label="c" :value="c" />
          </el-select>
        </el-form-item>
        <el-form-item label="购买时间">
          <el-date-picker class="desktop-date-picker" v-model="query.purchaseRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始" end-placeholder="结束" />
          <div class="mobile-date-range">
            <label class="mobile-date-field">
              <span>开始</span>
              <input v-model="query.purchaseDateStart" class="mobile-date-input" type="date" aria-label="购买开始日期">
            </label>
            <label class="mobile-date-field">
              <span>结束</span>
              <input v-model="query.purchaseDateEnd" class="mobile-date-input" type="date" aria-label="购买结束日期">
            </label>
          </div>
        </el-form-item>
        <el-form-item label="卖出时间">
          <el-date-picker class="desktop-date-picker" v-model="query.saleRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始" end-placeholder="结束" />
          <div class="mobile-date-range">
            <label class="mobile-date-field">
              <span>开始</span>
              <input v-model="query.saleDateStart" class="mobile-date-input" type="date" aria-label="卖出开始日期">
            </label>
            <label class="mobile-date-field">
              <span>结束</span>
              <input v-model="query.saleDateEnd" class="mobile-date-input" type="date" aria-label="卖出结束日期">
            </label>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="page-card">
      <el-tabs v-model="active" @tab-click="load">
        <el-tab-pane label="按品牌" name="brand">
          <el-table :data="brandRows" border stripe empty-text="暂无统计数据">
            <el-table-column prop="groupName" label="品牌" min-width="160" />
            <el-table-column prop="totalCount" label="总数量" width="90" />
            <el-table-column prop="stockCount" label="库存数量" width="100" />
            <el-table-column prop="soldCount" label="卖出数量" width="100" />
            <el-table-column prop="totalCost" label="总成本" width="140" align="right"><template slot-scope="scope">¥{{ money(scope.row.totalCost) }}</template></el-table-column>
            <el-table-column prop="stockCost" label="库存成本" width="140" align="right"><template slot-scope="scope">¥{{ money(scope.row.stockCost) }}</template></el-table-column>
            <el-table-column prop="totalSale" label="总销售额" width="140" align="right"><template slot-scope="scope">¥{{ money(scope.row.totalSale) }}</template></el-table-column>
            <el-table-column prop="totalProfit" label="利润" width="140" align="right"><template slot-scope="scope"><span :class="Number(scope.row.totalProfit || 0) >= 0 ? 'profit-positive' : 'profit-negative'">¥{{ money(scope.row.totalProfit) }}</span></template></el-table-column>
            <el-table-column prop="profitMarginPct" label="利润率" width="100" align="right"><template slot-scope="scope"><span v-if="scope.row.profitMarginPct !== null" :class="Number(scope.row.profitMarginPct) >= 0 ? 'profit-positive' : 'profit-negative'">{{ scope.row.profitMarginPct }}%</span><span v-else class="text-muted">-</span></template></el-table-column>
            <el-table-column prop="avgHoldDays" label="平均持有天数" width="120" align="right"><template slot-scope="scope">{{ scope.row.avgHoldDays !== null ? scope.row.avgHoldDays + '天' : '-' }}</template></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="按货号" name="itemNo">
          <el-table :data="itemNoRows" border stripe empty-text="暂无统计数据">
            <el-table-column prop="groupName" label="货号" min-width="160" />
            <el-table-column prop="totalCount" label="总数量" width="90" />
            <el-table-column prop="stockCount" label="库存数量" width="100" />
            <el-table-column prop="soldCount" label="卖出数量" width="100" />
            <el-table-column prop="totalCost" label="总成本" width="140" align="right"><template slot-scope="scope">¥{{ money(scope.row.totalCost) }}</template></el-table-column>
            <el-table-column prop="stockCost" label="库存成本" width="140" align="right"><template slot-scope="scope">¥{{ money(scope.row.stockCost) }}</template></el-table-column>
            <el-table-column prop="totalSale" label="总销售额" width="140" align="right"><template slot-scope="scope">¥{{ money(scope.row.totalSale) }}</template></el-table-column>
            <el-table-column prop="totalProfit" label="利润" width="140" align="right"><template slot-scope="scope"><span :class="Number(scope.row.totalProfit || 0) >= 0 ? 'profit-positive' : 'profit-negative'">¥{{ money(scope.row.totalProfit) }}</span></template></el-table-column>
            <el-table-column prop="profitMarginPct" label="利润率" width="100" align="right"><template slot-scope="scope"><span v-if="scope.row.profitMarginPct !== null" :class="Number(scope.row.profitMarginPct) >= 0 ? 'profit-positive' : 'profit-negative'">{{ scope.row.profitMarginPct }}%</span><span v-else class="text-muted">-</span></template></el-table-column>
            <el-table-column prop="avgHoldDays" label="平均持有天数" width="120" align="right"><template slot-scope="scope">{{ scope.row.avgHoldDays !== null ? scope.row.avgHoldDays + '天' : '-' }}</template></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="按月份" name="month">
          <div ref="monthChart" class="month-chart"></div>
          <el-table :data="monthRows" border stripe>
            <el-table-column prop="month" label="月份" min-width="100" />
            <el-table-column prop="purchaseCount" label="买入数量" width="100" />
            <el-table-column prop="purchaseAmount" label="买入金额" width="140" align="right"><template slot-scope="scope">¥{{ money(scope.row.purchaseAmount) }}</template></el-table-column>
            <el-table-column prop="soldCount" label="卖出数量" width="100" />
            <el-table-column prop="saleAmount" label="卖出金额" width="140" align="right"><template slot-scope="scope">¥{{ money(scope.row.saleAmount) }}</template></el-table-column>
            <el-table-column prop="profit" label="利润" width="140" align="right"><template slot-scope="scope"><span :class="Number(scope.row.profit || 0) >= 0 ? 'profit-positive' : 'profit-negative'">¥{{ money(scope.row.profit) }}</span></template></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { reportByBrand, reportByItemNo, reportByMonth } from '@/api/reports'
import { money } from '@/utils/format'

const emptyQuery = () => ({ brandName: '', itemNo: '', category: '', purchaseRange: [], saleRange: [], purchaseDateStart: '', purchaseDateEnd: '', saleDateStart: '', saleDateEnd: '' })

export default {
  name: 'Reconciliation',
  data() {
    return {
      categories: ['鞋', '服装', '包', '配饰', '其他'],
      active: 'brand',
      query: emptyQuery(),
      brandRows: [],
      itemNoRows: [],
      monthRows: [],
      chart: null
    }
  },
  mounted() {
    this.load()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    money,
    params() {
      const p = { ...this.query }
      if (p.purchaseRange && p.purchaseRange.length === 2) { p.purchaseDateStart = p.purchaseRange[0]; p.purchaseDateEnd = p.purchaseRange[1] }
      if (p.saleRange && p.saleRange.length === 2) { p.saleDateStart = p.saleRange[0]; p.saleDateEnd = p.saleRange[1] }
      delete p.purchaseRange; delete p.saleRange
      Object.keys(p).forEach(k => { if (!p[k]) delete p[k] })
      return p
    },
    async load() {
      const p = this.params()
      if (this.active === 'brand') this.brandRows = await reportByBrand(p)
      if (this.active === 'itemNo') this.itemNoRows = await reportByItemNo(p)
      if (this.active === 'month') {
        this.monthRows = await reportByMonth(p)
        this.$nextTick(this.renderMonthChart)
      }
    },
    reset() { this.query = emptyQuery(); this.load() },
    renderMonthChart() {
      if (!this.$refs.monthChart) return
      if (!this.chart) this.chart = echarts.init(this.$refs.monthChart)
      this.chart.setOption({
        color: ['#2563eb', '#10b981', '#f59e0b'],
        tooltip: { trigger: 'axis' },
        legend: { top: 0, data: ['买入金额', '卖出金额', '利润'] },
        grid: { left: 48, right: 24, top: 46, bottom: 36 },
        xAxis: { type: 'category', data: this.monthRows.map(i => i.month) },
        yAxis: { type: 'value' },
        series: [
          { name: '买入金额', type: 'bar', data: this.monthRows.map(i => i.purchaseAmount || 0) },
          { name: '卖出金额', type: 'bar', data: this.monthRows.map(i => i.saleAmount || 0) },
          { name: '利润', type: 'line', smooth: true, data: this.monthRows.map(i => i.profit || 0) }
        ]
      })
    },
    resizeChart() { if (this.chart) this.chart.resize() }
  }
}
</script>

<style scoped>
.month-chart { height: 300px; margin-bottom: 16px; }
</style>
